<template src="./html/Show.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Navbar from './Navbar'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'navbar': Navbar,
		},
		data () {
			return {
				data: null,
			}
		},
		created () {
			this.init()
		},
		watch: {
			'$route': function () {
				this.data = null
				this.getData()
			},
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/management/delivery/notes/' + this.$route.params.id)
				.then(response => {
					this.data = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/deliveryNotes/views/Show.vue